import { hideModal } from '@shared/ui/modal.util';

class RequestProductSuccessModalController {
    constructor($state) {
        'ngInject';

        this.$state = $state;
    }

    redirect() {
        hideModal('requestProductSuccessModal');

        if (this.$state.current.name !== 'deposit') {
            this.$state.go('deposit');
        }
    }

    close() {
        hideModal('requestProductSuccessModal');
    }
}

export default RequestProductSuccessModalController;



// WEBPACK FOOTER //
// ./client/app/shared/system-components/request-product/success.modal.controller.js